"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixEllipsis = void 0;
function fixEllipsis(text) {
    return (text
        // removes spaces between dots
        .replace(/\.([ ]+)(?=[.])/g, ".")
        // replaces three dots with ellipsis character
        .replace(/[ \t]*\.{3,}/g, "…")
        // replaces more than one ellipsis with one
        .replace(/(…){2,}/g, "…")
        // replaces (space|tab|zwnj) after ellipsis with one space
        .replace(/([ ]{1,})*…[ \t\u200c]*/g, "$1… "));
}
exports.fixEllipsis = fixEllipsis;
